$(function () {
    $.fn.swipe = function (callback) {
        var touchDown = false,
          originalPosition = null,
          $el = $(this);

        function swipeInfo(event) {
            console.log(event);
            var x = event.originalEvent.pageX || event.originalEvent.targetTouches[0].pageX,
              y = event.originalEvent.pageY || event.originalEvent.targetTouches[0].pageY,
              dx, dy;

            dx = (x > originalPosition.x) ? "right" : "left";
            dy = (y > originalPosition.y) ? "down" : "up";

            return {
                direction: {
                    x: dx,
                    y: dy
                },
                offset: {
                    x: x - originalPosition.x,
                    y: originalPosition.y - y
                }
            };
        }

        $el.on("touchstart mousedown", function (event) {
            event.preventDefault();

            touchDown = true;
            originalPosition = {
                x: event.originalEvent.pageX || event.originalEvent.targetTouches[0].pageX,
                y: event.originalEvent.pageY || event.originalEvent.targetTouches[0].pageY
            };
        });

        $el.on("touchend mouseup", function () {
            touchDown = false;
            originalPosition = null;
        });

        $el.on("mousemove", function (event) {
            if (!touchDown) { return; }
            var info = swipeInfo(event);
            callback(info.direction, info.offset);
        });

        $el.on("touchmove", function (event) {
            if (!touchDown) { return; }
            var info = swipeInfo(event);
            callback(info.direction, info.offset);

            touchDown = false;
            originalPosition = null;
        });

        return true;
    };
});

(function ($) {
    var elts = [];
    var pagination;
    var prev = -1;
    var current = 0;
    var offset = 0;
    var that;
    var lastScrollTop = 0;
    var startY = 0;

    $.fn.euroviaSlider = function (options) {
        // Establish our default settings
        var settings = $.extend({
            delay: 10000
        }, options);
        var offsetDelta = 141;//$("header").outerHeight();
        that = this;

        //console.log(window.location.href);
        //console.log(window.location.hostname);
        //console.log(window.location.host);

        if ($("[data-pos]").length > 0) {
            manageOverflow('hidden');
        }

        pagination = addPagination();
        setDimensions();

        offset = $(that).height() + offsetDelta;
        $("[data-id]").not(".firstSlide").css("top", offset);

        pagination.find(".pager").each(function (i, obj) {
            $(obj).click(function (e) {
                e.preventDefault();

                offset = $(that).height() + offsetDelta;
                var next = $(obj).attr('data-moveTo');
                $(that).moveTo(next);
            });
        });

        $(window).on('mousewheel DOMMouseScroll', function (e) {
            offset = $(that).height() + offsetDelta;
            var nnext = 0;
            var direction = (function () {
                var delta = (e.type === 'DOMMouseScroll' ?
                e.originalEvent.detail * -40 :
                e.originalEvent.wheelDelta);
                return delta > 0 ? 0 : 1;
            }());

            if (direction === 1) {
                nnext = parseInt(current) + 1;
            }
            if (direction === 0) {
                nnext = parseInt(current) - 1;
            }

            if (nnext > -1 && nnext < $(that).find("[data-pos]").length / 2) {
                $(that).moveTo(nnext);
            } else {
                //console.log('nnext ' + nnext);
                //console.log('$(that).find("[data-pos]").length ' + $(that).find("[data-pos]").length);
            }
        });

        $(that).swipe(function (direction, offset) {
            console.log("Moving", direction.x, "and", direction.y);
            console.log("Touch moved by", offset.x, "horizontally and", offset.y, "vertically");

            var nnext = 0;
            var direction = offset.y < 0;

            if (offset.y == 0) {
                return;
            }

            if (!direction) {
                nnext = parseInt(current) + 1;
            }
            else{
                nnext = parseInt(current) - 1;
            }

            if (nnext > -1 && nnext < $(that).find("[data-pos]").length / 2) {
                $(that).moveTo(nnext);
            } else {
                //console.log('nnext ' + nnext);
                //console.log('$(that).find("[data-pos]").length ' + $(that).find("[data-pos]").length);
            }
        });

        $(window).resize(function () {
            setDimensions();
        });

        //GESTION URL HASH
        var hash = window.location.hash;
        //console.log(hash);
        if (hash != "") {
            var id = $("[data-hash=" + hash + "]:first").attr("data-id");
            $(".pager").eq(id).click();
        }
    };

    $.fn.moveTo = function (next) {
        if (next != current) {
            updateLinkedZone(current, next);

            if (next == 0) {
                var leftMove = $("[data-id=" + current + "][data-pos=left]");
                var rightMove = $("[data-id=" + current + "][data-pos=right]");
                var leftCurrent = $("[data-id=" + current + "][data-pos=left]");
                var rightCurrent = $("[data-id=" + current + "][data-pos=right]");

                $(".pager:eq(" + current + ")").removeClass("active");
                $(".pager:eq(" + next + ")").addClass("active");

                var zindex = parseInt(leftCurrent.css("z-index")) + 5;
                leftMove.css("z-index", zindex).addClass("firstSlide");
                rightMove.css("z-index", zindex).addClass("firstSlide");
                $("[data-id=" + next + "].slideContentLeft").addClass("firstSlide").css({ "z-index": 5 });

                leftMove.velocity({
                    top: offset
                },
                    1000
                );
                rightMove.velocity({
                    top: -offset
                },
                    1000
                );
            } else {
                var leftMove = $("[data-id=" + next + "][data-pos=left]");
                var rightMove = $("[data-id=" + next + "][data-pos=right]");

                var leftCurrent = $("[data-id=" + current + "][data-pos=left]");
                var rightCurrent = $("[data-id=" + current + "][data-pos=right]");
                var toDown = false;

                $(".pager:eq(" + current + ")").removeClass("active");
                $(".pager:eq(" + next + ")").addClass("active");
                //console.log("offset: " + offset);
                if (next > current) {
                    //next gauche vient du bas et next droit vient du haut
                    leftMove.css("top", offset);
                    rightMove.css("top", -offset);
                    toDown = true;
                } else {
                    //inversement
                    leftMove.css("top", -offset);
                    rightMove.css("top", offset);
                    toDown = false;
                }

                if (!toDown) {
                    var zindex = parseInt(leftCurrent.css("z-index")) + 5;
                    leftMove.css("z-index", zindex).addClass("firstSlide");
                    rightMove.css("z-index", zindex).addClass("firstSlide");
                }

                leftMove.velocity({
                    top: 0
                },
                    1000,
                    function () {
                        complete(leftCurrent, rightCurrent, toDown);
                    }
                );
                rightMove.velocity({
                    top: 0
                },
                    1000,
                    function () {
                        complete(leftCurrent, rightCurrent, toDown);
                    }
                );

                if (toDown) {
                    var zindex = parseInt(leftCurrent.css("z-index")) + 2
                    leftMove.css("z-index", zindex).addClass("firstSlide");
                    rightMove.css("z-index", zindex).addClass("firstSlide");
                }
            }

            current = next;
        } else {
            //console.log("nothing to move");
        }
    }

    function RemoveIndication() {
        if ($(".scrollIndication").length > 0) {
            $(".scrollIndication").fadeOut();
        }
    }

    function updateLinkedZone(current, next) {
        $("[data-scroll=" + next + "]").parent().addClass("current");
        $("[data-scroll=" + current + "]").parent().removeClass("current");
    }

    function complete(leftCurrent, rightCurrent, toDown) {
        RemoveIndication();

        leftCurrent.removeClass("firstSlide");
        rightCurrent.removeClass("firstSlide");

        leftCurrent.css("z-index", -1);
        rightCurrent.css("z-index", -1);
    }

    function addPagination() {
        var pager = '<div class="sliderPagination">';
        for (i = 0; i < $(that).find("[data-pos]").length / 2; i++) {
            pager += '<div class="pager ' + (i == 0 ? "active" : "") + '" data-moveTo="' + i + '"></div>';
        }
        pager += '</div>';
        $(that).append(pager);

        return $(".sliderPagination");
    }

    function setDimensions() {
        //console.log(that);
        var windowHeight = $(window).height();
        var headerHeight = $("header").outerHeight();
        //console.log("windowHeight " + windowHeight);
        //console.log("headerHeight " + headerHeight);

        var height = windowHeight - headerHeight;
        //console.log("height " + height);
        //var width = $(window).width();

        //console.log("no top");
        $(that).css("top", 0);
        $(that).css("height", height);
        //$(that).css("width", width);

        //$(".slideContentLeft").css("height", height).not(".full").css("width", width / 2);
        //$(".slideContentRight").css("height", height).not(".full").css("width", width / 2);

        pagerHeight = $(".sliderPagination").height();
        //console.log("pagerHeight " + pagerHeight);
        var pagerTop = (height / 2) - (pagerHeight / 2);
        //pagerTop
        //console.log("pagerTop " + pagerTop);
        $(".sliderPagination").css("top", pagerTop);

        $("[data-vcentered]").each(function (i, obj) {
            var height = $(that).height();
            var VCheight = $(obj).height();
            $(obj).css("padding-top", (height - VCheight) / 2);
            $(obj).css("padding-bottom", (height - VCheight) / 2);
        });
    }

    function manageOverflow(mode) {
        $("body").css("overflow", mode);
        $("html").css("overflow", mode);
    }
}(jQuery));